import '../../modules/mode-components';
import '../validators/hal-text-validator';

import * as angular from 'angular';

import { DefinitionRunService } from '../../services/definition-run-service';
import { DatasourceFacade } from '@mode/accounts/domain';

// Rename is a misnomer here. Definitions cannot be renamed
// This modal allows modification of the description and datasource

const renameDefinitionDirective = function (
  Modal,
  datasourceFacade: DatasourceFacade,
  AlertService,
  DefinitionRunDataService: DefinitionRunService
) {
  return {
    restrict: 'A',
    scope: {
      definition: '<?renameDefinition',
      modalTitle: '@',
      modalConfirm: '&',
      account: '<',
    },
    link: function ($scope: any, elem, attrs) {
      elem.on('click.context', (event) => {
        $scope.current = {
          name: $scope.definition.name,
          description: $scope.definition.description,
          dataSourceId: $scope.definition.dataSourceId,
        };

        datasourceFacade.loadDatasources();
        const modal = Modal.open(
          {
            current: $scope.current,
            title: $scope.modalTitle,
            account: $scope.account,
          },
          {
            template: `<create-definition-modal
                rename="true"
                account="account"
                current="current"
                title="title"
                on-confirm="$close($definition)"
                on-cancel="$dismiss()"
              ></create-definition-modal>`,
            animation: true,
            backdrop: 'static',
          }
        );

        modal.result
          .then(() => {
            DefinitionRunDataService.manageDefinition(
              $scope.definition.token,
              $scope.current.name,
              $scope.current.description,
              $scope.current.dataSourceId,
              $scope.definition.source,
              $scope.modalConfirm
            );
          })
          .catch(function () {});
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.context'));
    },
  };
};

renameDefinitionDirective.$inject = ['ModalService', 'DatasourceFacade', 'ToastService', 'DefinitionRunDataService'];

angular.module('mode.components').directive('renameDefinition', renameDefinitionDirective);
